/** Metrics shown after a skin scan (cosmetic guidance only). */
export type SkinScanMetricKey = 'hydration' | 'texture' | 'spots' | 'redness' | 'pores';

export type SkinScanScores = Partial<Record<SkinScanMetricKey, number>>;

export type SkinScanMatchQuery = {
  skinType: string;
  concern: string;
  texture: string;
  pace: string;
  tags: string[];
};

export type SkinScanResult = {
  mode: 'mock' | 'live';
  completedAt: string;
  scores: SkinScanScores;
  inferredConcern: string;
  faceDetected?: boolean;
  /** Present after live Perfect Corp analysis — feeds `GET /catalog/routine-match`. */
  matchQuery?: SkinScanMatchQuery;
};

export const DEFAULT_SKIN_SCAN_METRICS: SkinScanMetricKey[] = ['hydration', 'texture', 'spots'];

export const SKIN_SCAN_METRIC_LABELS: Record<SkinScanMetricKey, string> = {
  hydration: 'Hydratation',
  texture: 'Texture',
  spots: 'Taches',
  redness: 'Rougeurs',
  pores: 'Pores',
};
